import React from 'react'
export default function CodeOfConductPage(){
     return(
        <div className='mt-4 mb-4 w-[560px] m-auto'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Code of Conduct</h2>
        <p className='text-sm mb-12'>
         1. Community page is managed by Dev Cookbooks. Your post can be removed without notifying if it needed.<br/><br/>

         2. Loren Ipsum Loren Ipsum Loren Ipsum Loren Ipsum Loren Ipsum<br/><br/>

         3. Loren Ipsum Loren Ipsum Loren Ipsum Loren Ipsum Loren Ipsum<br/><br/>
         <br/>
        </p>
        <br/>
        </div>
     )
}
